import { gql } from '@apollo/client';

/** Connector Table DB - Connection Provider & Attributes */
export const QUERY_GET_CONNECTION_PROVIDER = gql`
  query AdminQueriesGetConnectors {
    AdminQueries {
      getConnectors {
        id
        name
        url
        connectionTypeId
        connectionTypeName
        __typename
      }
    }
  }
`;

export const MUTATION_CREATE_CONNECTOR = gql`
  mutation createNewConnector($name: String!, $url: String!, $connectionTypeId: Int!) {
    AdminMutations {
      createNewConnector(submission: { name: $name, url: $url, connectionTypeId: $connectionTypeId }) {
        submission {
          id
          name
        }
      }
    }
  }
`;

export const MUTATION_EDIT_CONNECTOR = gql`
  mutation editNewConnector($connectorId: Int!, $name: String!, $url: String!) {
    AdminMutations {
      editNewConnector(connectorId: $connectorId, submission: { name: $name, url: $url }) {
        submission {
          id
          name
          url
        }
      }
    }
  }
`;
